import React, {useState, useEffect} from 'react'
import {Dialog, DialogActions, DialogTitle, IconButton} from '@mui/material'
import {makeStyles} from '@mui/styles'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import {Colors, Spacing} from '../../assets/styles'
import NamePicker from './NamePicker'
import {RXRButton} from '../RXRButton'
import RXRIcon from '../RXRIcon'
import {iconButton} from '../../assets/styles/buttons'
import PropTypes from 'prop-types'

const Constants = {
  BTN_SUBMIT: 'Submit',
  MESSAGE: 'Which tenant is picking up this package from the front desk?',
}
const useStyles = makeStyles(theme => ({
  dialog: {
    maxWidth: '286px',
    '& .MuiDialogActions-root': {
      padding: '0px 8px 16px 16px',
      justifyContent: 'flex-start',
    },
  },
  closeButton: {
    ...iconButton,
    position: 'absolute',
    right: 12,
    top: 12,
    color: Colors.rxrDarkGreyColor,
    cursor: 'pointer',
  },
  cursorHand: {
    cursor: 'pointer',
  },
  messageText: {
    fontSize: 16,
    lineHeight: '18.75px',
    color: Colors.rxrBlackColor,
    margin: `${Spacing.spaceSmall}px 0`,
  },
}))

function WhoPickedUpModal(props) {
  const [name, setName] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    setName(null)
  }, [props.selectedPackageUnit])

  let handleClose = () => {
    setName(null)
    props.handleClose()
  }

  let handleSubmit = () => {
    props.handleSubmit(name)
  }

  return (
    <React.Fragment>
      <Dialog open={props.isOpen} onClose={handleClose} classes={{paper: classes.dialog}}>
        <DialogTitle>
          <IconButton className={classes.closeButton} onClick={handleClose} size="large">
            <RXRIcon icon={RXRIcon.CLOSE} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={classes.messageText}>{Constants.MESSAGE}</DialogContentText>
          <NamePicker selectedPackageUnit={props.selectedPackageUnit} name={name} setName={setName} />
        </DialogContent>
        <DialogActions>
          <RXRButton variant="contained" disabled={!name} onClick={handleSubmit}>
            {Constants.BTN_SUBMIT}
          </RXRButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

WhoPickedUpModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  selectedPackageUnit: PropTypes.string,
}

export default WhoPickedUpModal
